/**
 * pre validaciu do schemy:
 *
 * pre heslo:
 *  custom() {
 *     return validatePassword (this.value);
 *  }
 *
 * pre kontrolu hesla
 *  custom() {
 *     return validatePassword (this.value, this.field('password').value);
 *  }
 *
 *  vrati invalidPasswodStrength, passwordMismatch, alebo null ak je ok
 *  ak je heslo prazdne nevaliduje, vrati null
 *
 * @param value
 * @param password1
 * @returns {string|null}
 */
export const validatePassword = (value: string, password1 = '') => {
  if (value) {
    const strength = _passwordStrength(value)
    if (strength < STRONG_PASSW_MEDIUM) {
      return 'invalidPasswodStrength'
    }
  }
  //for password2, check value = password1
  if (password1) {
    if (value !== password1) {
      return 'passwordMismatch'
    }
  }
  return null
}

/**
 * https://www.thepolyglotdeveloper.com/2015/05/use-regex-to-test-password-strength-in-javascript/
 * 0 slabe
 * 1 stredne - 6 znakov Aa1[!@#$%^&*]
 * 2 silne heslo - 8 znakov Aa1[!@#$%^&*]
 */
export const STRONG_PASSW_THIN = 0
export const STRONG_PASSW_MEDIUM = 1
export const STRONG_PASSW_STRONG = 2
function _passwordStrength(value: string) {
  if (!value) {
    return STRONG_PASSW_THIN
  }
  /*
   *  (?=.*[a-z])	The string must contain at least 1 lowercase alphabetical character
   *  (?=.*[A-Z])	The string must contain at least 1 uppercase alphabetical character
   *  (?=.*[0-9])	The string must contain at least 1 numeric character
   *  (?=.*[!@#$%^&*])	The string must contain at least one special character, but we are escaping reserved RegEx characters to avoid conflict
   *  (?=.{8,})	The string must be eight characters or longer
   */
  const strongRegex = new RegExp(
    '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*\\-\\+=])(?=.{8,})'
  )
  const mediumRegex = new RegExp(
    '^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]))(?=.{8,})'
  )
  if (strongRegex.test(value)) {
    return STRONG_PASSW_STRONG
  } else if (mediumRegex.test(value)) {
    return STRONG_PASSW_MEDIUM
  }
  return STRONG_PASSW_THIN
}
